import { defineStore } from 'pinia'
import { ref, computed } from 'vue'
export const useUserStore = defineStore('user', () => {
  const stored = localStorage.getItem('chullaAppUser')
  const apiUser = ref(stored ? JSON.parse(stored) : null)
  const firebaseUser = ref(null)
  const key = computed(() => apiUser.value?.key)
  const token = computed(() => apiUser.value?.token)
  const refreshToken = computed(() => apiUser.value?.refreshToken)
  const currentUser = ref('');

  function setFirebaseUser(fbUser: any) {
    firebaseUser.value = fbUser
  }
  function setApiUser(user: any) {
    apiUser.value = user
    saveState()
  }
  function saveState() {
    const user = apiUser.value
    if (user) {
      localStorage.setItem('chullaAppUser', JSON.stringify(user))
    } else {
      localStorage.removeItem('chullaAppUser')
    }
  }
  function setTokens(tokens: any) {
    apiUser.value.key = tokens.key
    apiUser.value.token = tokens.token
    apiUser.value.refreshToken = tokens.refreshToken
    saveState()
  }
  function setCurrentUser(user: string) {
    currentUser.value = user;
  }
  return {
    setFirebaseUser,
    firebaseUser,
    setApiUser,
    key,
    token,
    refreshToken,
    apiUser,
    setTokens,
    currentUser,
    setCurrentUser
  }
})
